import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import { FormattedHTMLMessage, intlMessageShape } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import Picture from 'components/ui/Picture/Picture'

import messages from './messages'
import s from './UnsubscribeProduct.scss'


class UnsubscribeProduct extends Component {

  static propTypes = {
    title: PropTypes.shape(intlMessageShape).isRequired,
    link: PropTypes.string.isRequired,
    imageDesktop: PropTypes.object.isRequired,
    imageMobile: PropTypes.object.isRequired,
    onChoose: PropTypes.func,
  }

  render() {
    const { title, link, imageDesktop, imageMobile, onChoose } = this.props

    return (
      <div className={s.product}>
        <FormattedHTMLMessage {...title} />
        <Media mobile>
          {
            (isMobile) => (
              <Picture imgClassName={s.image} {...(isMobile ? imageMobile : imageDesktop)} />
            )
          }
        </Media>
        <Button
          className={s.button}
          brand
          md
          to={link}
          title={messages.buttonTitle}
          onClick={onChoose}
        />
      </div>
    )
  }
}


export default UnsubscribeProduct
